import React from "react";


function Account() {
    return(
        <h1>Member </h1>
    )
}

export default Account;